module.exports = __webpack_public_path__ + "img/7_20.8d093c63.png";